RivalIQ.apps.AccountSettings.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.CardSummary = Backbone.Model.extend({
        url: '/currentCard'
    });
});
